import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DiscountService } from '../../../services/DiscountService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import * as $ from 'jquery';

@Component({
  selector: 'app-discount-add',
  templateUrl: './discount-add.component.html',
  styleUrls: ['./discount-add.component.css']
})
export class DiscountAddComponent implements OnInit {


  

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any, private DiscountService: DiscountService, public snackBar: MatSnackBar, private GL_MasterService: GL_MasterService) {

    if (data != undefined && data.studentID != undefined) {
      this.studentID = data.studentID;
    }
  }
  studentID: string = "";

  ngOnInit() {
    $('input[name="studentID"]').val(this.studentID);
    this.getBranchId();
  }

  is_allow_save: boolean = true;
  isBranchId: number = -1;
  getBranchId() {
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
    }
  }



  selectedFile: File = null;
  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
    console.log("selected file");
    console.log(this.selectedFile);
  }
  onSubmit(f: NgForm) {
    if (f.valid) {
      console.log("Form Validity: " + f.valid);
      console.log("Form value : " + f.value['discountFile']);
      this.GL_MasterService.getStudentName(f.value["studentID"]).subscribe(a => {
        const result = a.json();
         
        console.log(result);
        if (result != undefined && (result.udF2 != this.isBranchId && this.isBranchId > 0)) {
          this.snackBar.open(null, 'شما دسترسی به این شعبه ندارید', {
            duration: 2000,
          } );
          this.is_allow_save = false;
          return;
        } else {
          this.is_allow_save = true;
        }

        if (result["gL_ChildCode"] != null) {
          //console.log("student ID: ");
          //console.log(a);
          this.DiscountService.addDiscount(f.value,this.selectedFile).subscribe(r => {
            $('input[name="studentID"]').val('');
            $('input[name="discountAmount"]').val('');
            $('input[name="comment"]').val('');
            if (r != 'Error') {
              this.snackBar.open(" اضافه شد", null, { duration: 5000 });
            } else {
              this.snackBar.open("خطا در ثبت", null, { duration: 5000 });
            }
          });
        } else {
          this.snackBar.open("محصل یافت نشد", null, { duration: 5000 });
        }
      });
    } else {
      this.snackBar.open("ورودی درست نیست", null, { duration: 5000 });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/discount/discount-add/discount-add.component.ts